import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Button} from 'semantic-ui-react';
import {FemaGoModal} from 'app-ui-componentlibrary';
import SearchOrganization from './searchOrganization';
import CreateSubOrganizationForm from './createSubOrganizationForm';
import ViewSubOrganization from './viewSubOrganization';
import ManualSubOrganization from './manualSubOrganization';
import {isValidDuns, isValidUei, isStringOfNumbers} from 'common/utils';
import ApiActions from 'go/actions/api';
import {
  API_ORG_GET_BY_DUNS_SUCCESS,
  API_ORG_GET_BY_UEIEFT_SUCCESS,
  API_ORG_GET_BY_DUNS_FROM_SAMGOV_SUCCESS,
  API_CREATE_ORG_REQUEST,
  API_CREATE_ORG_FAILURE,
  API_CREATE_SUB_ORG_SUCCESS,
  API_ORG_GET_ALL_SUBORGS_SUCCESS,
  API_PROGRAM_GET_BY_APPROVED_STATUS_SUCCESS,
  API_ORG_PROGRAM_GET_SUCCESS,
  API_PROGRAM_LIST_GET_SUCCESS,
} from 'common/types';

const MODAL_OPTIONS = {
  CREATE: 'create',
  NONE: 'none',
  SUCCESS: 'success',
};

const SEARCH_OPTIONS = {
  INITIAL: 'start',
  IN_PROGRESS: 'inprogress',
  FOUND: 'found',
  NOT_FOUND: 'notfound',
  ERROR: 'error',
};
let suborgname = '';
export class AddSubOrganizationContainer extends Component {
  constructor(props) {
    super(props);
    this.handleDoesSuborgExistInList = this.handleDoesSuborgExistInList.bind(this);
    this.state = {
      openModal: MODAL_OPTIONS.NONE,
      dunsNumber: '',
      uei: '',
      searching: SEARCH_OPTIONS.INITIAL,
      alreadyAssociated: null,
      errorPayload: {},
      responseErrorMessage: '',
      programs: [],
      programCheckedList: [],
      programNameList: [],
      programSelected: false,
      newOrganizationInfo: {},
    };
  }

  handleInputChange = (event) => {
    const {name, value} = event.target;
  };

  handleSearchInputChange = (event) => {
    event.preventDefault();
    const {name, value} = event.target;
    this.setState((prevState) => ({...prevState, [name]: value}));
  };

  validateAndGetDataByDUNSNumber = () => {
    const {token, toggles} = this.props;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
    const {dunsNumber, uei} = this.state;
    if (dunsToUEIToggle) {
      if (isValidUei(uei)) {
        this.setState({
          displayError: false,
          errorMessage: '',
          alreadyAssociated: null,
        });
        this.props
          .searchByUEI(token, uei)
          .then((resUEI) => {
            if (!(resUEI && resUEI.hasResults)) {
              let exists;
              this.handleDoesSuborgExistInList()
                .then((resSuborgExist) => {
                  if (resSuborgExist.hasResults) {
                    let suborg = _.filter(resSuborgExist.payload, (org) => {
                      return (
                        _.toLower(`${org.uei}-${org.eft}`) === _.toLower(uei) ||
                        _.toLower(org.uei) === _.toLower(uei)
                      );
                    });
                    exists = suborg.length > 0 ? true : false;
                    if (exists) {
                      return this.setState(
                        {
                          suborgs: suborg,
                          manualEntry: false,
                          searching: SEARCH_OPTIONS.FOUND,
                          newOrganizationInfo: suborg[0],
                        },
                        () => {
                          this.toggleAlreadyAssociated(exists);
                        }
                      );
                    } else {
                      return this.setState({
                        suborgs: [],
                        displayError: true,
                        errorMessage: 'No UEI-EFT found',
                        manualEntry: true,
                        searching: SEARCH_OPTIONS.NOT_FOUND,
                      });
                    }
                  } else {
                    let currentState = this.setState({
                      suborgs: [],
                      displayError: true,
                      errorMessage: 'No UEI-EFT found',
                      manualEntry: true,
                      searching: SEARCH_OPTIONS.NOT_FOUND,
                    });
                    return currentState;
                  }
                })
                .catch((error) => {
                  console.error('error');
                });
            } else {
              this.setState({
                suborgs: resUEI.payload,
                foundInSAMGov: resUEI.foundInSAMGov ? true : false,
                manualEntry: false,
                searching: SEARCH_OPTIONS.FOUND,
              });
              let exists;
              this.handleDoesSuborgExistInList()
                .then((resSuborgExist) => {
                  if (resSuborgExist.hasResults) {
                    let suborg = _.filter(resSuborgExist.payload, (org) => {
                      return (
                        _.toLower(`${org.uei}-${org.eft}`) === _.toLower(uei) ||
                        _.toLower(org.uei) === _.toLower(uei)
                      );
                    });
                    exists = suborg.length > 0 ? true : false;
                    if (exists) {
                      this.setState({
                        suborgs: suborg,
                        searching: SEARCH_OPTIONS.FOUND,
                        newOrganizationInfo: suborg[0],
                      });
                    }
                    this.toggleAlreadyAssociated(exists);
                  } else {
                    this.setState({newOrganizationInfo: resUEI.payload[0]});
                    this.toggleAlreadyAssociated(false);
                  }
                })
                .catch((error) => {
                  console.error('error');
                });
              if (!exists) {
                this.setState({newOrganizationInfo: resUEI.payload[0]});
              }
            }
          })
          .catch((error) => {
            console.error('error');
          });
      } else {
        this.setState({
          displayError: true,
          searching: SEARCH_OPTIONS.INITIAL,
          errorMessage:
            'You must enter a valid Unique Entity Identifier and EFT indicator combination (12 character UEI or 12 character UEI-4 character EFT).',
        });
      }
    } else {
      if (isValidDuns(dunsNumber)) {
        this.setState({
          displayError: false,
          errorMessage: '',
          alreadyAssociated: null,
        });
        this.props
          .searchByDUNSNumber(token, dunsNumber)
          .then((resDUNS) => {
            if (!(resDUNS && resDUNS.hasResults)) {
              let exists;
              this.handleDoesSuborgExistInList()
                .then((resSuborgExist) => {
                  if (resSuborgExist.hasResults) {
                    let suborg = _.filter(resSuborgExist.payload, (org) => {
                      if (isValidDuns(org.dunsPlus4, true)) {
                        return `${org.duns}${org.dunsPlus4}` === dunsNumber;
                      } else {
                        return org.duns === dunsNumber;
                      }
                    });
                    exists = suborg.length > 0 ? true : false;
                    if (exists) {
                      return this.setState(
                        {
                          suborgs: suborg,
                          manualEntry: false,
                          searching: SEARCH_OPTIONS.FOUND,
                          newOrganizationInfo: suborg[0],
                        },
                        () => {
                          this.toggleAlreadyAssociated(exists);
                        }
                      );
                    } else {
                      return this.setState({
                        suborgs: [],
                        displayError: true,
                        errorMessage: 'No DUNS# found',
                        manualEntry: true,
                        searching: SEARCH_OPTIONS.NOT_FOUND,
                      });
                    }
                  } else {
                    let currentState = this.setState({
                      suborgs: [],
                      displayError: true,
                      errorMessage: 'No DUNS# found',
                      manualEntry: true,
                      searching: SEARCH_OPTIONS.NOT_FOUND,
                    });
                    return currentState;
                  }
                })
                .catch((error) => {
                  console.error('error');
                });
            } else {
              this.setState({
                suborgs: resDUNS.payload,
                foundInSAMGov: resDUNS.foundInSAMGov ? true : false,
                manualEntry: false,
                searching: SEARCH_OPTIONS.FOUND,
              });
              let exists;
              this.handleDoesSuborgExistInList()
                .then((resSuborgExist) => {
                  if (resSuborgExist.hasResults) {
                    let suborg = _.filter(resSuborgExist.payload, (org) => {
                      if (isValidDuns(org.dunsPlus4, true)) {
                        return `${org.duns}${org.dunsPlus4}` === dunsNumber;
                      } else {
                        return org.duns === dunsNumber;
                      }
                    });
                    exists = suborg.length > 0 ? true : false;
                    if (exists) {
                      this.setState({
                        suborgs: suborg,
                        searching: SEARCH_OPTIONS.FOUND,
                        newOrganizationInfo: suborg[0],
                      });
                    }
                    this.toggleAlreadyAssociated(exists);
                  } else {
                    this.setState({newOrganizationInfo: resDUNS.payload[0]});
                    this.toggleAlreadyAssociated(false);
                  }
                })
                .catch((error) => {
                  console.error('error');
                });
              if (!exists) {
                this.setState({newOrganizationInfo: resDUNS.payload[0]});
              }
            }
          })
          .catch((error) => {
            console.error('error');
          });
      } else {
        this.setState({
          displayError: true,
          searching: SEARCH_OPTIONS.INITIAL,
          errorMessage: 'Please enter a valid 9 or 13 digit number.',
        });
      }
    }
  };

  searchDUNSAction = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({
      ...prevState,
      searching: SEARCH_OPTIONS.IN_PROGRESS,
    }));
    this.validateAndGetDataByDUNSNumber();
  };

  showModal = () => {
    const {toggles} = this.props;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
    return (
      <FemaGoModal
        type="alert"
        size="small"
        title="Search for the suborganization you wish to add"
        className="modal-title"
        open={this.state.openModal === MODAL_OPTIONS.CREATE}
        confirmButton="hidden"
        cancelAction={() =>
          this.setState({
            openModal: MODAL_OPTIONS.NONE,
            errorPayload: {},
            responseErrorMessage: '',
            programCheckedList: [],
            programNameList: [],
          })
        }
        closeOnDimmerClick="no"
      >
        {dunsToUEIToggle ? (
          <span className="modal-instructions">
            You can add a suborganization by searching for a 12 character or 12
            character-4 character Unique Entity Identifier-Electronic Funds Transfer
            indicator (UEI-EFT). The results will be displayed for you to confirm before
            adding. If the organization does not exist in SAM.gov, you must add this
            suborganization manually.
          </span>
        ) : (
          <span className="modal-instructions">
            You can add a suborganization by searching for a 9-digit or 13-digit DUNS
            number. The results will be displayed for you to confirm before adding. If the
            organization does not exist in SAM.gov or in FEMA GO, you may add this
            suborganization manually.
          </span>
        )}
        <br />
        <br />
        <br />

        <SearchOrganization
          dunsNumber={this.state.dunsNumber}
          uei={this.state.uei}
          handleInputChange={(event) => this.handleSearchInputChange(event)}
          handleSubmit={(event) => this.searchDUNSAction(event)}
          loading={this.state.searching === SEARCH_OPTIONS.IN_PROGRESS}
          displayError={this.state.displayError}
          errorMessage={this.state.errorMessage}
          dunsToUEIToggle={dunsToUEIToggle}
        />
        {this.showResults()}
      </FemaGoModal>
    );
  };
  successModal = () => {
    const {toggles} = this.props;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
    return (
      <FemaGoModal
        type="alert"
        size="small"
        title="Search for the suborganization you wish to add"
        className="modal-title"
        open={this.state.openModal === MODAL_OPTIONS.CREATE}
        confirmButton="hidden"
        cancelAction={() =>
          this.setState({
            openModal: MODAL_OPTIONS.NONE,
            errorPayload: {},
            responseErrorMessage: '',
          })
        }
        cancelButtonText="Close"
        closeOnDimmerClick="no"
      >
        {dunsToUEIToggle ? (
          <span className="modal-instructions">
            You can add a suborganization by searching for a 12 character or 12
            character-4 character Unique Entity Identifier-Electronic Funds Transfer
            indicator (UEI-EFT). The results will be displayed for you to confirm before
            adding. If the organization does not exist in SAM.gov, you must add this
            suborganization manually.
          </span>
        ) : (
          <span className="modal-instructions">
            You can add a suborganization by searching for a 9-digit or 13-digit DUNS
            number. The results will be displayed for you to confirm before adding. If the
            organization does not exist in SAM.gov or in FEMA GO, you may add this
            suborganization manually.
          </span>
        )}
        <br />
        <br />
        <br />

        <SearchOrganization
          dunsNumber={this.state.dunsNumber}
          uei={this.state.uei}
          handleInputChange={(event) => this.handleSearchInputChange(event)}
          handleSubmit={(event) => this.searchDUNSAction(event)}
          loading={this.state.searching === SEARCH_OPTIONS.IN_PROGRESS}
          displayError={this.state.displayError}
          errorMessage={this.state.errorMessage}
          dunsToUEIToggle={dunsToUEIToggle}
        />
        {this.showResults()}
      </FemaGoModal>
    );
  };

  runValidation = (orgPayload, programCheckedList) => {
    const {toggles} = this.props;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
    const isDirect = this.isDirectProgramsOnlySelected(programCheckedList);
    let validated = {};
    if (_.isEmpty(orgPayload.dunsNumber)) {
      if (!dunsToUEIToggle) {
        validated.dunsNumber = 'Please enter a valid 9 or 13 digit number.';
      }
    } else {
      if (!isValidDuns(orgPayload.dunsNumber)) {
        validated.dunsNumber = 'Please enter a valid 9 or 13 digit number.';
      }
    }
    orgPayload.ein && orgPayload.ein.length > 9
      ? (validated.ein = 'Please enter a valid number under 9 digits.')
      : '';
    _.isEmpty(orgPayload.legalBusinessName)
      ? (validated.legalBusinessName = 'Please enter organization name.')
      : '';
    _.isEmpty(orgPayload.addresses[0].addressLine1)
      ? (validated.addressLine1 = 'Please enter address.')
      : '';
    _.isEmpty(orgPayload.mailingAddress.addressLine1)
      ? (validated.addressLine1 = 'Please enter address.')
      : '';
    _.isEmpty(orgPayload.addresses[0].city)
      ? (validated.city = 'Please enter city.')
      : '';
    _.isEmpty(orgPayload.mailingAddress.city)
      ? (validated.city = 'Please enter city.')
      : '';
    _.isEmpty(orgPayload.addresses[0].stateOrProvince)
      ? (validated.stateOrProvince = 'Please select state.')
      : '';
    _.isEmpty(orgPayload.mailingAddress.stateOrProvince)
      ? (validated.stateOrProvince = 'Please select state.')
      : '';
    _.isEmpty(orgPayload.addresses[0].zip)
      ? (validated.zip = 'Please enter zip code.')
      : isStringOfNumbers(orgPayload.addresses[0].zip)
      ? (validated.zip = 'Please use numbers')
      : '';
    _.isEmpty(orgPayload.mailingAddress.zip)
      ? (validated.zip = 'Please enter zip code.')
      : isStringOfNumbers(orgPayload.mailingAddress.zip)
      ? (validated.zip = 'Please use numbers')
      : '';
    _.isEmpty(orgPayload.physicalAddress.addressLine1)
      ? (validated.physical_addressLine1 = 'Please enter address.')
      : '';
    _.isEmpty(orgPayload.physicalAddress.city)
      ? (validated.physical_city = 'Please enter city.')
      : '';
    _.isEmpty(orgPayload.physicalAddress.stateOrProvince)
      ? (validated.physical_stateOrProvince = 'Please select state.')
      : '';
    _.isEmpty(orgPayload.physicalAddress.zip)
      ? (validated.physical_zip = 'Please enter zip code.')
      : isStringOfNumbers(orgPayload.physicalAddress.zip)
      ? (validated.physical_zip = 'Please use numbers')
      : '';
    if (!isDirect) {
      _.isEmpty(orgPayload.contacts[0].firstName)
        ? (validated.firstName = 'Please enter first name.')
        : '';
      _.isEmpty(orgPayload.contacts[0].lastName)
        ? (validated.lastName = 'Please enter last name.')
        : '';
      if (_.isEmpty(orgPayload.contacts[0].title)) {
        validated.title = 'Please enter title.';
      }
      _.isEmpty(orgPayload.contacts[0].email)
        ? (validated.email = 'Please enter email.')
        : '';
    }
    programCheckedList.length === 0
      ? (validated.programCheckedList = 'Please provide required program.')
      : '';
    this.setState({
      errorPayload: validated,
    });
    return validated;
  };

  runProgValidation = (programCheckedList) => {
    let validated = {};
    programCheckedList.length === 0
      ? (validated.programCheckedList = 'Please provide required program.')
      : '';
    this.setState({
      errorPayload: validated,
    });
    return validated;
  };

  closeModal = () => {
    this.setState({
      openModal: MODAL_OPTIONS.NONE,
    });
  };

  handleAddSubOrganization = (suborg, programList) => {
    const {token, organizationId} = this.props;
    const payload = {
      entityId: String(suborg.organizationId),
      programIds: programList,
    };
    this.props
      .addSubOrganization(token, organizationId, suborg.organizationId, payload)
      .then((res) => {
        if (res) {
          this.setState({
            openModal: MODAL_OPTIONS.SUCCESS,
            suborgs: [suborg],
          });
        }
      });
    this.props.fetchMoreData({});
    suborgname = _.get(
      this.state,
      'suborgs.0.displayName',
      _.get(this.state, 'suborgs.0.legalName')
    );
  };

  isDirectProgramsOnlySelected = (programCheckedList) => {
    const {programs} = this.state;
    const useSuborgToggle = _.get(this.props, 'toggles', []).includes(
      'useSuborganization'
    );
    if (useSuborgToggle) {
      const programList = _.filter(programs, (program) =>
        programCheckedList.includes(program.programId)
      );
      const directFilteredList = _.filter(programList, (program) => {
        if (program.useSuborganizationFlag) {
          return program;
        }
      });
      if (_.isEmpty(programList)) {
        return false;
      } else if (_.isEqual(programList, directFilteredList)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  getSelectedDirectPrograms = (programCheckedList) => {
    const useSuborgToggle = _.get(this.props, 'toggles', []).includes(
      'useSuborganization'
    );
    const {programs} = this.state;
    if (useSuborgToggle) {
      const programList = _.filter(programs, (program) =>
        programCheckedList.includes(program.programId)
      );
      const directFilteredList = _.filter(programList, (program) => {
        if (program.useSuborganizationFlag) {
          return program;
        }
      });
      if (!_.isEmpty(directFilteredList)) {
        return directFilteredList;
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  handleDoesSuborgExistInList = async () => {
    let exists;
    await this.props
      .getAllExistingSubOrg(
        this.props.token,
        this.props.organizationId,
        this.props.programId
      )
      .then((res) => {
        exists = res;
      })
      .catch((error) => {
        console.error('error');
      });
    return exists;
  };

  handleSaveOrganization = async (orgPayload) => {
    const {token, organizationId} = this.props;
    const payload = orgPayload;
    let result;
    await this.props
      .createSubOrganization(token, payload, organizationId)
      .then((res) => {
        res.type === API_CREATE_ORG_FAILURE
          ? this.setState({
              responseErrorMessage:
                'An error occurred while processing your request - please try again.',
            })
          : this.setState({
              openModal: MODAL_OPTIONS.SUCCESS,
              newOrganizationInfo: _.get(res, 'payload.organization'),
            });
        result = res;
      })
      .catch((error) => {
        console.error('error');
      });
    this.props.fetchMoreData({});
    return result;
  };
  toggleSuccessModal = () => {
    const {
      newOrganizationInfo,
      openModal,
      suborgs,
      alreadyAssociated,
      foundInSAMGov,
      programCheckedList,
      programNameList,
    } = this.state;
    const {toggles} = this.props;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
    return (
      <FemaGoModal
        type="alert"
        size="small"
        title={`${
          _.get(newOrganizationInfo, 'displayName')
            ? _.get(newOrganizationInfo, 'displayName')
            : _.get(newOrganizationInfo, 'legalName')
        } is successfully added`}
        className="modal-title"
        open={openModal === MODAL_OPTIONS.SUCCESS}
        confirmButton="hidden"
        cancelAction={() =>
          this.setState({
            openModal: MODAL_OPTIONS.NONE,
            programCheckedList: [],
            programNameList: [],
            programSelected: false,
          })
        }
        cancelButtonText="Close"
        closeOnDimmerClick="no"
      >
        {suborgs !== undefined ? (
          <ViewSubOrganization
            parentOrganizationId={this.props.organizationId}
            organization={newOrganizationInfo}
            alreadyAssociated={alreadyAssociated}
            toggleAlreadyAssociated={this.toggleAlreadyAssociated}
            handleAddSubOrganization={this.handleAddSubOrganization}
            handleSaveOrganization={this.handleSaveOrganization}
            handleDoesSuborgExistInList={this.handleDoesSuborgExistInList}
            addedSuccess={true}
            closeModal={this.closeModal}
            foundInSAMGov={foundInSAMGov}
            programCheckedList={programCheckedList}
            programNameList={programNameList}
            getCurrentOrgDisplayName={this.props.getCurrentOrgDisplayName}
            dunsToUEIToggle={dunsToUEIToggle}
          />
        ) : (
          ''
        )}
      </FemaGoModal>
    );
  };
  successResults = () => {
    const {toggles} = this.props;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
    const useSuborgToggle = _.includes(toggles, 'useSuborganization');
    return (
      <ViewSubOrganization
        parentOrganizationId={this.props.organizationId}
        organization={this.state.newOrganizationInfo}
        searchAgain={this.searchAgain}
        alreadyAssociated={this.state.alreadyAssociated}
        toggleAlreadyAssociated={this.toggleAlreadyAssociated}
        handleAddSubOrganization={this.handleAddSubOrganization}
        handleSaveOrganization={this.handleSaveOrganization}
        handleDoesSuborgExistInList={this.handleDoesSuborgExistInList}
        foundInSAMGov={this.state.foundInSAMGov}
        handlePrograms={this.handlePrograms}
        programs={this.state.programs}
        programCheckedList={this.state.programCheckedList}
        programNameList={this.state.programNameList}
        programSelected={this.state.programSelected}
        handleProgramCheckbox={this.handleProgramCheckbox}
        handleSelectProgram={this.handleSelectProgram}
        handleGetAllPrograms={this.handleGetAllPrograms}
        createOrgAddPayload={this.createOrgAddPayload}
        runValidation={this.runProgValidation}
        errorPayload={this.state.errorPayload}
        dunsToUEIToggle={dunsToUEIToggle}
        useSuborgToggle={useSuborgToggle}
      />
    );
  };

  filterPrograms = (programs) => {
    const useSuborgToggle = _.get(this.props, 'toggles', []).includes(
      'useSuborganization'
    );
    let programListFiltered = _.filter(programs, (program) => {
      if (useSuborgToggle) {
        if (program.subapplicationFlag || program.useSuborganizationFlag) {
          return program;
        }
      } else {
        if (program.subapplicationFlag) {
          return program;
        }
      }
    });
    return programListFiltered;
  };

  handlePrograms = () => {
    const {token, getOrgPrograms, getProgramInfo, organizationId} = this.props;
    getOrgPrograms(token, organizationId).then((res) => {
      const programs = res.payload.organizationPrograms;

      // so make sure you are a parent org for this program, you may only be able to manage perms for it.
      let parentPrograms = _.filter(
        programs,
        (program) =>
          !_.has(program, 'parentOrganizations') ||
          _.get(program, 'parentOrganizations.0.organizationId') == organizationId
      );

      let ids = new Set(
        _.map(parentPrograms, (program) => {
          return program.programId;
        })
      );
      let params = Array.from(ids).toString();
      getProgramInfo(token, params).then((res) => {
        if (res) {
          let programs = res.payload;
          let programsFiltered = this.filterPrograms(programs);
          programs = _.orderBy(programsFiltered, ['programName'], ['asc']);
          this.setState({programs});
        }
      });
    });
  };

  handleSelectProgram = (e, categoryId, programCheckedList, programNameList) => {
    const {checked} = e.target;
    const useSuborgToggle = _.get(this.props, 'toggles', []).includes(
      'useSuborganization'
    );
    let collection = [];
    let nameCollection = [];
    if (!useSuborgToggle) {
      if (checked) {
        collection = this.handleGetAllPrograms();
        nameCollection = this.handleGetAllProgramsName();
      }
      this.setState({
        programCheckedList: collection,
        programNameList: nameCollection,
        programSelected: checked,
      });
    } else {
      if (checked) {
        const programsToAdd = _.filter(
          categoryId.programsList,
          (program) => !programCheckedList.includes(program.programId)
        ).map((p) => p.programId);
        const programNamesToAdd = _.filter(categoryId.programsList, (program) =>
          programsToAdd.includes(program.programId)
        ).map((p) => p.programName);
        this.setState({
          programCheckedList: _.concat(programCheckedList, programsToAdd),
          programNameList: _.concat(programNameList, programNamesToAdd),
        });
      } else {
        const programsToRemove = categoryId.programsList.map((p) => p.programId);
        const programNamesToRemove = categoryId.programsList.map((p) => p.programName);
        const newProgramCheckedList = _.filter(
          programCheckedList,
          (p) => !programsToRemove.includes(p)
        );
        const newProgramNameList = _.filter(
          programNameList,
          (p) => !programNamesToRemove.includes(p)
        );
        this.setState({
          programCheckedList: newProgramCheckedList,
          programNameList: newProgramNameList,
        });
      }
    }
  };

  handleGetAllPrograms = () => {
    const {programs} = this.state;
    const collection = [];
    for (const prog of programs) {
      collection.push(prog.programId);
    }
    return collection;
  };

  handleGetAllProgramsName = () => {
    const {programs} = this.state;
    const collection = [];
    for (const prog of programs) {
      collection.push(prog.programDescription + ' (' + prog.programName + ')');
    }
    return collection;
  };

  handleProgramCheckbox = (e) => {
    const {value, checked, name} = e.target;
    const useSuborgToggle = _.get(this.props, 'toggles', []).includes(
      'useSuborganization'
    );
    if (!useSuborgToggle) {
      if (checked) {
        const collection = this.handleGetAllPrograms();
        this.setState((prevState) => ({
          programCheckedList: [...prevState.programCheckedList, value * 1],
          programNameList: [...prevState.programNameList, name],
          programSelected: collection.length === prevState.programCheckedList.length + 1,
        }));
      } else {
        this.setState((prevState) => ({
          programCheckedList: _.filter(
            prevState.programCheckedList,
            (item) => item != value
          ),
          programNameList: _.filter(prevState.programNameList, (item) => item != name),
          programSelected: false,
        }));
      }
    } else {
      if (checked) {
        this.setState((prevState) => ({
          programCheckedList: [...prevState.programCheckedList, value * 1],
          programNameList: [...prevState.programNameList, name],
        }));
      } else {
        this.setState((prevState) => ({
          programCheckedList: _.filter(
            prevState.programCheckedList,
            (item) => item != value
          ),
          programNameList: _.filter(prevState.programNameList, (item) => item != name),
        }));
      }
    }
  };

  noResults = () => {
    const {toggles} = this.props;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
    const useSuborgToggle = _.includes(toggles, 'useSuborganization');
    return (
      <ManualSubOrganization
        handleSubOrganizationForm={this.addManualSubOrganization}
        searchAgain={this.searchAgain}
        toggleManualForm={this.toggleManualForm}
      >
        {!this.state.manualEntry ? (
          <React.Fragment>
            <br />
            <br />
            <CreateSubOrganizationForm
              title="Enter suborganization manually"
              handleInputChange={this.handleInputChange}
              handleSaveOrganization={this.handleSaveOrganization}
              handleAddSubOrganization={this.handleAddSubOrganization}
              runValidation={this.runValidation}
              createOrgPostPayload={this.createOrgPostPayload}
              errorPayload={this.state.errorPayload}
              displayError={false}
              responseErrorMessage={this.state.responseErrorMessage}
              handlePrograms={this.handlePrograms}
              programs={this.state.programs}
              programNameList={this.state.programNameList}
              programCheckedList={this.state.programCheckedList}
              programSelected={this.state.programSelected}
              handleProgramCheckbox={this.handleProgramCheckbox}
              handleSelectProgram={this.handleSelectProgram}
              handleGetAllPrograms={this.handleGetAllPrograms}
              dunsToUEIToggle={dunsToUEIToggle}
              useSuborgToggle={useSuborgToggle}
              disableAORSection={this.isDirectProgramsOnlySelected(
                this.state.programCheckedList
              )}
              displayDirectPrograms={this.getSelectedDirectPrograms(
                this.state.programCheckedList
              )}
            />
          </React.Fragment>
        ) : (
          ''
        )}
      </ManualSubOrganization>
    );
  };

  createOrgPostPayload = (orgData, progData) => {
    const isDirect = this.isDirectProgramsOnlySelected(progData);
    const {
      legalBusinessName,
      dunsNumber,
      dunsNumberPlus4,
      ein,
      isManuallyAdded,
    } = orgData;
    const payload = {
      programIds: progData,
      registrationStatus: 'A',
      legalBusinessName,
      dunsNumber,
      dunsNumberPlus4,
      ein,
      isManuallyAdded,
      contacts: isDirect ? undefined : orgData.contacts,
      bankDTOList: [],
      addresses: [
        {
          addressLine1: orgData.mailingAddress.addressLine1,
          addressLine2: orgData.mailingAddress.addressLine2,
          city: orgData.mailingAddress.city,
          stateOrProvince: orgData.mailingAddress.stateOrProvince,
          zip: orgData.mailingAddress.zip,
          zipPlus4: orgData.mailingAddress.zipPlus4,
          county: orgData.mailingAddress.county,
          country: null,
          type: 'MAILING',
        },
        {
          addressLine1: orgData.physicalAddress.addressLine1,
          addressLine2: orgData.physicalAddress.addressLine2,
          city: orgData.physicalAddress.city,
          stateOrProvince: orgData.physicalAddress.stateOrProvince,
          zip: orgData.physicalAddress.zip,
          zipPlus4: orgData.physicalAddress.zipPlus4,
          county: orgData.physicalAddress.county,
          country: null,
          type: 'PHYSICAL',
        },
      ],
    };
    this.handleSaveOrganization(payload);
  };

  searchAgain = (event) => {
    event.preventDefault();
    this.setState({
      openModal: MODAL_OPTIONS.CREATE,
      dunsNumber: '',
      searching: SEARCH_OPTIONS.INITIAL,
      displayError: false,
      errorPayload: {},
      errorMessage: '',
      manualEntry: false,
    });
  };

  showResults = () => {
    if (this.state.searching === SEARCH_OPTIONS.FOUND) {
      return this.successResults();
    } else if (this.state.searching === SEARCH_OPTIONS.NOT_FOUND) {
      return this.noResults();
    }
  };

  addManualSubOrganization = () => {
    this.setState({manualEntry: !this.state.manualEntry});
  };

  toggleAlreadyAssociated = (bool) => {
    this.setState({
      alreadyAssociated: bool,
    });
  };

  addSubOrgHandler = (event) => {
    this.setState({
      openModal: MODAL_OPTIONS.CREATE,
      dunsNumber: '',
      searching: SEARCH_OPTIONS.INITIAL,
      displayError: false,
      errorMessage: '',
    });
  };

  render() {
    return (
      <React.Fragment>
        <Button id="addSubOrganization" primary onClick={(e) => this.addSubOrgHandler(e)}>
          {' '}
          + Add a suborganization
        </Button>
        {this.showModal()}
        {this.toggleSuccessModal()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    auth: state.auth,
    toggles: state.toggles.toggles,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  searchByDUNSNumber: (token, dunsNumber) => {
    const action = ApiActions.organization.getOrganizationByDUNS(token, dunsNumber);
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_ORG_GET_BY_DUNS_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  searchByUEI: (token, uei) => {
    const action = ApiActions.organization.getOrganizationByUEIEFT(token, uei);
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_ORG_GET_BY_UEIEFT_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  searchByDUNSNumberInSAMGov: (token, dunsNumber) => {
    const action = ApiActions.organization.getOrganizationByDUNSFromSAMGOV(
      token,
      dunsNumber
    );
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_ORG_GET_BY_DUNS_FROM_SAMGOV_SUCCESS && !_.isEmpty(res.payload);
      res.foundInSAMGov = true;
      return res;
    });
  },
  createSubOrganization: (token, payload, orgId) => {
    const action = ApiActions.organization.createSubOrg(token, payload, orgId);
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults = res.type === API_CREATE_ORG_REQUEST && !_.isEmpty(res.payload); // TODO, how is this working? Shouldn't this be API_CREATE_SUB_ORG_SUCCESS ?
      return res;
    });
  },
  addSubOrganization: (token, orgId, subOrgId, payload) => {
    const action = ApiActions.organization.addAndEditSubOrg(
      token,
      orgId,
      subOrgId,
      payload
    );
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults = res.type === API_CREATE_SUB_ORG_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  getAllExistingSubOrg: (token, orgId, programId) => {
    const action = ApiActions.organization.getAllSuborganizations(
      token,
      orgId,
      programId
    );
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_ORG_GET_ALL_SUBORGS_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  getAllApprovedPrograms: (token) => {
    const action = ApiActions.program.getProgramsByApprovedStatus(token);
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_PROGRAM_GET_BY_APPROVED_STATUS_SUCCESS &&
        !_.isEmpty(res.payload);
      return res;
    });
  },
  getOrgPrograms: (token, orgId) => {
    const action = ApiActions.organizationRelationship.getAllOrganizationProgramsByOrgId(
      token,
      orgId
    );
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_ORG_PROGRAM_GET_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  getProgramInfo: (token, params) => {
    const action = ApiActions.program.getProgramList(token, params);
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_PROGRAM_LIST_GET_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
});

const AddSubOrganization = connect(
  mapStateToProps,
  mapDispatchToProps
)(AddSubOrganizationContainer);

export default AddSubOrganization;
